import mapboxgl from "mapbox-gl";

// @ts-ignore
// eslint-disable-next-line
mapboxgl.workerClass =
  // eslint-disable-next-line
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;
